import React from 'react';
import {
    Box,
    Paper,
    Skeleton,
    Stack,
    Divider
} from '@mui/material';

const TableSkeleton = ({ rows = 5, showHeader = true, showActions = true }) => {
    return (
        <Paper sx={{ borderRadius: 2, overflow: 'hidden' }}>
            {showHeader && (
                <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
                    <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                        <Skeleton variant="text" width="30%" height={28} />
                        <Box sx={{ flex: 1 }} />
                        <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: 1 }} />
                        <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1 }} />
                    </Stack>
                    
                    {/* Filter row */}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <Skeleton variant="rectangular" width={200} height={36} sx={{ borderRadius: 1 }} />
                        <Skeleton variant="rectangular" width={150} height={36} sx={{ borderRadius: 1 }} />
                        <Skeleton variant="rectangular" width={180} height={36} sx={{ borderRadius: 1 }} />
                    </Stack>
                </Box>
            )}
            
            <Box sx={{ p: 2 }}>
                {Array.from({ length: rows }).map((_, index) => (
                    <React.Fragment key={index}>
                        <Stack 
                            direction="row" 
                            spacing={2} 
                            alignItems="center" 
                            sx={{ py: 2 }}
                        >
                            {/* Icon */}
                            <Skeleton variant="circular" width={40} height={40} />
                            
                            {/* Main content */}
                            <Box sx={{ flex: 1 }}>
                                <Skeleton variant="text" width="70%" height={20} sx={{ mb: 0.5 }} />
                                <Skeleton variant="text" width="50%" height={16} sx={{ mb: 0.5 }} />
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Skeleton variant="rectangular" width={60} height={20} sx={{ borderRadius: 1 }} />
                                    <Skeleton variant="text" width="30%" height={14} />
                                </Stack>
                            </Box>
                            
                            {/* Actions */}
                            {showActions && (
                                <Stack direction="row" spacing={1}>
                                    <Skeleton variant="circular" width={32} height={32} />
                                    <Skeleton variant="circular" width={32} height={32} />
                                    <Skeleton variant="circular" width={32} height={32} />
                                </Stack>
                            )}
                        </Stack>
                        {index < rows - 1 && <Divider />}
                    </React.Fragment>
                ))}
            </Box>
        </Paper>
    );
};

export default TableSkeleton; 